/**
 * Route for `data-residency`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DataResidencyPage } from "../features/data-residency/DataResidencyPage";

export const dataResidencyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/data-residency",
	component: DataResidencyPage,
});

export default dataResidencyRoute;
